import React, { useEffect, useRef, useState } from 'react';
import {
  Box, Table, TableBody, TableCell, TableContainer, TableHead, TableRow,
  Paper, TextField, IconButton, Grid, Tooltip, TablePagination, Dialog, DialogTitle, DialogContent
} from '@mui/material';
import PrintIcon from '@mui/icons-material/Print';
import VisibilityIcon from '@mui/icons-material/Visibility';
import axios from 'axios';
import { useReactToPrint } from 'react-to-print';
import { BRAND } from '../constants/brand';
import Autocomplete from '@mui/material/Autocomplete';

function Billhistory() {
  const ReturnprintsRef = useRef();
  const PRINT_BILL_BODY_FONT_SIZE_PX = 10;
  const [billHeaders, setBillHeaders] = useState([]);
  const [filteredBills, setFilteredBills] = useState([]);
  const [searchTerm, setSearchTerm] = useState('');
  const [selectedBillItems, setSelectedBillItems] = useState([]);
  const [selectedBillMeta, setSelectedBillMeta] = useState(null);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [viewOpen, setViewOpen] = useState(false);

  useEffect(() => {
    axios.get('https://serverdemo.ccsoftwares.com/billing/getBillHeaders')
      .then(res => {
        setBillHeaders(res.data);
        setFilteredBills(res.data);
      })
      .catch(err => console.error('Error fetching bill headers:', err));
  }, []);

  useEffect(() => {
    const term = searchTerm.toLowerCase();
    const filtered = billHeaders.filter(bill =>
      bill.inv_no.toLowerCase().includes(term) ||
      (bill.Vehicle_no || '').toLowerCase().includes(term)
    );
    setFilteredBills(filtered);
  }, [searchTerm, billHeaders]);

  const handlePrint = async (inv_no) => {
    await loadBill(inv_no, { openView: false, print: true });
  };

  const handleView = async (inv_no) => {
    await loadBill(inv_no, { openView: true, print: false });
  };

  const loadBill = async (inv_no, { openView, print }) => {
    try {
      const res = await axios.post(`https://serverdemo.ccsoftwares.com/billing/getSingleBill`, { inv_no });
      if (res.data && res.data.length > 0) {
        const first = res.data[0];
        const meta = {
          inv_no: first.billNo || inv_no,
          username: first.username,
          inv_date: first.inv_date,
          gross_total: first.gross_total,
          discount: first.discount,
          net_total: first.net_total,
          Service_chrg: first.Service_chrg,
          customer_name: first.Customer_name,
          vehicle_no: first.Vehicle_no,
          model: first.model,
          mileage: first.Milage,
          chassis_number: first.chassis_number,
          technician: first.TechnicianName,
          payment_method:
            first.payment_method ??
            first.paymentMethod ??
            first.Method ??
            first.method,
          amount_paid:
            first.amount_paid ??
            first.amountPaid ??
            first.Amount ??
            first.amount,
          balance:
            first.balance ??
            first.Balance ??
            first.balanceAmount,
        };
        setSelectedBillItems(res.data);
        setSelectedBillMeta(meta);
        if (openView) {
          setViewOpen(true);
        }
        if (print) {
          setTimeout(() => handlePrintTrigger(), 200);
        }
      }
    } catch (err) {
      console.error('Error fetching single bill:', err);
    }
  };

  const handlePrintTrigger = useReactToPrint({
    content: () => ReturnprintsRef.current,
  });

  const formatTwoDigits = (val) => (val < 10 ? `0${val}` : val);

  const renderBillContent = (visible = false) => {
    if (!selectedBillMeta || selectedBillItems.length === 0) return null;

    const invDate = selectedBillMeta.inv_date ? new Date(selectedBillMeta.inv_date) : new Date();
    const year = invDate.getFullYear();
    const month = formatTwoDigits(invDate.getMonth() + 1);
    const day = formatTwoDigits(invDate.getDate());
    const hours = formatTwoDigits(invDate.getHours());
    const minutes = formatTwoDigits(invDate.getMinutes());
    const grossTotal = parseFloat(selectedBillMeta.gross_total || 0);
    const discountValue = parseFloat(selectedBillMeta.discount || 0);
    const netTotal = parseFloat(selectedBillMeta.net_total || (grossTotal - discountValue));
    const paymentMethod = selectedBillMeta?.payment_method || 'Cash / Card';
    const amountPaid = selectedBillMeta?.amount_paid != null ? parseFloat(selectedBillMeta.amount_paid) : netTotal;
    const balance = selectedBillMeta?.balance != null ? parseFloat(selectedBillMeta.balance) : 0;
    const lineDiscountTotal = selectedBillItems.reduce((sum, itm) => sum + (parseFloat(itm.lineItemDiscount || 0)), 0);
    const priceDiscountTotal = selectedBillItems.reduce((sum, itm) => {
      const qty = parseFloat(itm.qty) || 0;
      const originalPrice = parseFloat(itm.ItemSellingPrice ?? itm.unitprice ?? 0);
      const discountedPrice = itm.ItemDiscountedPrice ? parseFloat(itm.ItemDiscountedPrice) : null;
      const effectivePrice = discountedPrice && discountedPrice > 0 ? discountedPrice : originalPrice;
      const diff = originalPrice - effectivePrice;
      return diff > 0 ? sum + diff * qty : sum;
    }, 0);
    const totalDiscountSum = lineDiscountTotal + priceDiscountTotal + discountValue;
    let displayLineNo = 0;

    return (
      <div style={{ display: visible ? 'block' : 'none' }}>
        <div
          ref={!visible ? ReturnprintsRef : null}
          style={{
            width: '210mm',
            height: '297mm',
            minHeight: '297mm',
            padding: '12mm',
            paddingBottom: '27mm',
            backgroundColor: '#fff',
            color: '#000',
            fontFamily: 'Consolas, monospace',
            display: 'flex',
            flexDirection: 'column',
            boxSizing: 'border-box',
            gap: '10px'
          }}
        >
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
            <img src={require('../Assests/billLogo.png')} alt='' width={120} style={{ objectFit: 'contain', filter: 'grayscale(100%)' }} />
            <div style={{ textAlign: 'center', flex: 1, margin: '0 20px' }}>
              <div style={{ fontSize: '24px', letterSpacing: '1px' }}>DEMO Garage</div>
              <div style={{ fontSize: '16px', letterSpacing: '1px' }}>Vehicle Repairing and Service</div>
              <hr></hr>
              <div style={{ fontSize: '9px', marginTop: '4px' }}>
                Hybrid Repairs, EFI, Common Rail Vehicles, SRS Air Bag, ABS System, Vehicle Scanning, Running Repairs &amp; Engine Repairs, Brand New &amp; Recondition Spare Parts &amp; Lubricants
                <br />
              </div>
              <div style={{ fontSize: '12px', marginTop: '4px' }}>
                {BRAND.addressLine1 ? `${BRAND.addressLine1}, ` : ''}{BRAND.addressLine2} <br />
                {BRAND.telephone}
              </div>
            </div>
            <div style={{ fontSize: '18px' }}>INVOICE</div>
          </div>
          <hr />
          <div style={{ fontSize: PRINT_BILL_BODY_FONT_SIZE_PX }}>
            <div style={{ textAlign: 'center' }}>Invoice No: {selectedBillMeta.inv_no}</div>
            <hr />
            <div style={{ display: 'flex', justifyContent: 'space-between', gap: '100px' }}>
              <div style={{ flex: 1 }}>
                <div><span>Customer:</span> {selectedBillMeta.customer_name || '-'}</div>
                <div><span>Vehicle Model:</span> {selectedBillMeta.model || '-'}</div>
                <div><span>Chassis Number:</span> {selectedBillMeta.chassis_number || '-'}</div>
              </div>
              <div style={{ flex: 1 }}>
                <div><span>Vehicle No:</span> {selectedBillMeta.vehicle_no || '-'}</div>
                <div><span>Mileage:</span> {selectedBillMeta.mileage || '-'} km</div>
                <div><span>Date:</span> {`${year}-${month}-${day}`}</div>
              </div>
            </div>
            <hr />
            <table style={{ width: '100%', borderCollapse: 'collapse' }}>
              <thead>
                <tr>
                  {['No', 'Description', 'QTY', 'Amount', 'Discount', 'Total'].map((head) => (
                    <th
                      key={head}
                      style={{
                        border: 'none',
                        padding: '6px',
                        textAlign:
                          head === 'Description'
                            ? 'left'
                            : head === 'QTY' || head === 'No'
                              ? 'center'
                              : 'right',
                        fontWeight: 'normal',
                      }}
                    >
                      {head}
                    </th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {selectedBillItems?.map((e, i) => {
                  const isDescriptionOnlyRow =
                    typeof e.item_name === 'string' &&
                    /^\s+/.test(e.item_name) &&
                    Number(e.qty || 0) === 0 &&
                    Number(e.unitprice || 0) === 0;

                  if (isDescriptionOnlyRow) {
                    return (
                      <tr key={`${e.item_name}-${i}`}>
                        <td style={{ border: 'none', padding: '0 6px 6px 6px' }}></td>
                        <td colSpan={5} style={{ border: 'none', padding: '0 6px 6px 22px', color: '#000' }}>
                          {e.item_name.trim()}
                        </td>
                      </tr>
                    );
                  }

                  displayLineNo += 1;
                  const qty = parseFloat(e.qty) || 0;
                  const originalPrice = parseFloat(e.ItemSellingPrice ?? e.unitprice ?? 0);
                  const discountedPrice = e.ItemDiscountedPrice ? parseFloat(e.ItemDiscountedPrice) : null;
                  const effectivePrice = discountedPrice && discountedPrice > 0 ? discountedPrice : originalPrice;
                  const lineDiscount = parseFloat(e.lineItemDiscount || 0);
                  const unitPriceDiscount =
                    discountedPrice && discountedPrice > 0
                      ? Math.max(originalPrice - discountedPrice, 0) * qty
                      : 0;
                  const discountAmount = Math.max(unitPriceDiscount + lineDiscount, 0);
                  const lineTotal = Math.max(qty * effectivePrice - lineDiscount, 0);
                  return (
                    <tr key={`${e.item_name}-${i}`}>
                      <td style={{ border: 'none', padding: '6px', textAlign: 'center' }}>{displayLineNo}</td>
                      <td style={{ border: 'none', padding: '6px' }}>{e.item_name}</td>
                      <td style={{ border: 'none', padding: '6px', textAlign: 'center' }}>{qty}</td>
                      <td style={{ border: 'none', padding: '6px', textAlign: 'right' }}>{originalPrice.toFixed(2)}</td>
                      <td style={{ border: 'none', padding: '6px', textAlign: 'right' }}>
                        {discountAmount > 0 ? discountAmount.toFixed(2) : ''}
                      </td>
                      <td style={{ border: 'none', padding: '6px', textAlign: 'right' }}>{lineTotal.toFixed(2)}</td>
                    </tr>
                  );
                })}
                <tr>
                  <td colSpan={5} style={{ border: 'none', padding: '6px', textAlign: 'right' }}>Total</td>
                  <td style={{ border: 'none', padding: '6px', textAlign: 'right' }}>{netTotal.toFixed(2)}</td>
                </tr>
              </tbody>
            </table>
            <div style={{ color: '#000' }}>Discount: Rs. {totalDiscountSum.toFixed(2)}</div>
            <hr />
            <table style={{ width: '100%', borderCollapse: 'collapse' }}>
              <thead>
                <tr>
                  {['Payment Method', 'Amount Paid', 'Balance'].map((head) => (
                    <th key={head} style={{ border: 'none', padding: '6px', textAlign: 'left', fontWeight: 'normal' }}>{head}</th>
                  ))}
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td style={{ border: 'none', textAlign: 'left', paddingLeft: '6px' }}>{paymentMethod}</td>
                  <td style={{ border: 'none', textAlign: 'left', paddingLeft: '6px' }}>{amountPaid.toFixed(2)}</td>
                  <td style={{ border: 'none', textAlign: 'left', paddingLeft: '6px' }}>{balance.toFixed(2)}</td>
                </tr>
              </tbody>
            </table>
          </div>
          <div style={{ marginTop: 'auto', pageBreakInside: 'avoid', pageBreakBefore: 'avoid' }}>
            <hr />
            <div style={{ fontFamily: 'consolas', display: 'flex', justifyContent: 'space-around', fontSize: PRINT_BILL_BODY_FONT_SIZE_PX }}>
              <div>
                <span>Bank Account Details</span>
                <div>Account Name: {BRAND.name}</div>
              </div>
              <div>
                BOC - Kirindiwela : 0000000000 <br />
                HNB - Kirindiwela : 0000000000
              </div>
            </div>
            <hr />
            <div style={{ textAlign: 'center', fontSize: 10 }}>
              <div>Thank you. Come again.</div>
              <div>Software by CC Software Solutions | 077 0832 340</div>
            </div>
          </div>
        </div>
      </div>
    );
  };

  return (
    <Box p={2} style={{ paddingTop: '100px' }}>
      <div style={{ textAlign: 'left', marginBottom: '20px', fontSize: '30px', fontWeight: 'bold' }}>
        Bill History
      </div>
      <Grid container spacing={2} sx={{ mb: 2 }}>
        <Grid item xs={12} md={6}>
          <Autocomplete
            freeSolo
            options={Array.from(new Set(billHeaders.map(b => b.Vehicle_no).filter(Boolean)))}
            value={searchTerm}
            onInputChange={(e, val) => setSearchTerm(val)}
            renderInput={(params) => (
              <TextField
                {...params}
                label="Search Invoice / Vehicle No"
                variant="outlined"
                fullWidth
              />
            )}
          />
        </Grid>
      </Grid>

      <TableContainer component={Paper} sx={{ maxHeight: 600, overflowY: 'auto' }}>
        <Table size="small" stickyHeader>
          <TableHead>
            <TableRow>
              <TableCell style={{ fontWeight: 'bold' }}>Invoice No</TableCell>
              <TableCell style={{ fontWeight: 'bold' }}>Inv Date</TableCell>
              <TableCell style={{ fontWeight: 'bold' }}>Vehicle</TableCell>
              <TableCell style={{ fontWeight: 'bold' }}>Gross</TableCell>
              <TableCell style={{ fontWeight: 'bold' }}>Discount</TableCell>
              <TableCell style={{ fontWeight: 'bold' }}>Net</TableCell>
              <TableCell style={{ fontWeight: 'bold' }}>Job Done By</TableCell>
              <TableCell style={{ fontWeight: 'bold' }}>Cashier</TableCell>
              <TableCell style={{ fontWeight: 'bold' }}>Action</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {(rowsPerPage > 0
              ? filteredBills.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
              : filteredBills
            ).map((bill, idx) => (
              <TableRow key={idx}>
                <TableCell>{bill.inv_no}</TableCell>
                <TableCell>{bill.inv_date}</TableCell>
                <TableCell>{bill.Vehicle_no || '-'}</TableCell>
                <TableCell>{bill.gross_total}</TableCell>
                <TableCell>{bill.discount}</TableCell>
                <TableCell>{bill.net_total}</TableCell>
                <TableCell>{bill.TechnicianName || bill.technician || bill.Job_Done_By || '-'}</TableCell>
                <TableCell>{bill.username}</TableCell>
                <TableCell>
                  <Tooltip title="View Bill">
                    <IconButton onClick={() => handleView(bill.inv_no)}>
                      <VisibilityIcon />
                    </IconButton>
                  </Tooltip>
                  <Tooltip title="Print">
                    <IconButton onClick={() => handlePrint(bill.inv_no)}>
                      <PrintIcon />
                    </IconButton>
                  </Tooltip>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
      <TablePagination
        component="div"
        count={filteredBills.length}
        page={page}
        onPageChange={(e, newPage) => setPage(newPage)}
        rowsPerPage={rowsPerPage}
        onRowsPerPageChange={(e) => {
          setRowsPerPage(parseInt(e.target.value, 10));
          setPage(0);
        }}
        rowsPerPageOptions={[10, 25, 50, { label: 'All', value: -1 }]}
      />

      {renderBillContent(false)}

      <Dialog
        open={viewOpen}
        onClose={() => setViewOpen(false)}
        fullWidth
        maxWidth="md"
      >
        <DialogTitle>Bill Preview - {selectedBillMeta?.inv_no}</DialogTitle>
        <DialogContent dividers>
          {renderBillContent(true)}
        </DialogContent>
      </Dialog>
    </Box>
  );
}

export default Billhistory;
